import commaNumber from 'comma-number';

export const commaSeparatedNumbers = (inputNumber: number | string) => {
  return commaNumber(inputNumber);
};
